exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n  border-radius: 13px;\n  background-color: #FE7440;\n  padding: 8px;\n  border: none;\n  -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.18);\n          box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.18);\n  font-weight: 600; }\n\n@media (max-width: 700px) {\n  .col-md-2 {\n    width: 30%; }\n  .col-md-10 {\n    width: 70%; }\n  .small-font {\n    font-size: 18px !important; }\n  .pad1 {\n    padding: 10px; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/itheunrealist/techpixels/src/app/header/header.component.scss
// module id = ../../../../../src/app/header/header.component.scss
// module chunks = main